import calcRandomInRange from "../../../objects/CommonUse/calc_random_in_range";
import ReduxGetGameInfo from "../../../redux/redux_get_game_info";

export const determineLoanIntRateChange = (baseRate) => {
    let calcIntRate = 0;
    let lowAdjust = 0;
    let highAdjust = 0;
    let type = "";
    const creditReport = ReduxGetGameInfo("creditReport");
    const creditScore = creditReport.creditScore;
    switch (true){
        case creditScore >= 760:
            lowAdjust = 2.5;
            highAdjust = 4.0;
            type = "minus";
            break;
        case creditScore >= 700:
            lowAdjust = .75;
            highAdjust = 2.0;
            type = "minus";
            break;
        case creditScore >= 640:
            lowAdjust = .25;
            highAdjust = 1.25;
            type = "plus";
            break;
        default:
            lowAdjust = 3.0;
            highAdjust = 1.75;
            type = "plus";
            break;
    }
    let intRateAdjust = calcRandomInRange(lowAdjust, highAdjust, 1);
    intRateAdjust = intRateAdjust /100;
    if (type === "minus"){
        calcIntRate = baseRate - intRateAdjust;
    }else{
        calcIntRate = baseRate + intRateAdjust;
    }
    calcIntRate = +calcIntRate.toFixed(4);
    return calcIntRate;
  
}
export default determineLoanIntRateChange;